import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import useSettings from "../../hooks/Settings";
import { useHistory } from "react-router-dom";
import { client } from "../../hooks/Client.js";
import Tooltip from "../../components/common/Tooltip";

const PremiumIcon = () => {
  const history = useHistory();
  const { subscription } = useSettings();

  return (
    <>
    {subscription === 'free' && 
        <div className='premium-icon-container' onClick={() => {history.push(`/${client}/subscription`)}}>
            <Tooltip content='Premium functie' width={'20px'} height={'20px'}>
                <ArrowCircleUpOutlinedIcon/>
            </Tooltip>
        </div>
    }
    </>
  )
}

export default PremiumIcon